<template>
    <div class="pl-1.5 pt-0.5 grid grid-cols-2 gap-2 w-full">
      <div class="w-full">
        <div class="mb-1.5">
          <img id="company" src="@/assets/images/icons8-company-24.png" alt="company" class="w-[24px] inline pr-1"/> {{client.id}} | {{ client.client_name }}
        </div>
        <div class="mb-1.5 flex flex-col">
            <div>
                <base-pill>Address:</base-pill> {{ fullAddress }}
            </div>
            <div>
                <base-pill>TZ:</base-pill> {{ client.time_zone }}
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    export default {
      name: 'contact-personal-info',
      data: () => ({
      }),
      methods: {
      }
    }
  
  </script>
  
  
  <script setup>

  import { ref, computed, defineProps,defineEmits } from 'vue';
  
  
      const emit = defineEmits(['refetch-contacts'])
  
      const fetchNewContacts = () => {
        emit('refetch-contacts')
      }
  
      const props = defineProps({
          client: Object
      })

      const companyCampaign = computed(()=> {
        return props.company.campaign ? props.company.campaign.campaign_name : '--'
      })

const fullAddress = computed(() => {
    return props.client ? `${props.client.address ? props.client.address : '--'} ${props.client.city ? props.client.city : '--'}, ${props.client.state ? props.client.state : '--'}` : '--'
})
  
  </script>